import { Debounce } from '../debounce.class'

/**
 * @file Defines the {@link GuaranteedDebounce} class
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Fires function at beginning and end of debounce periood
  * @extends Debounce
  */
 export class GuaranteedDebounce extends Debounce {

    /**
     * Most recent passed argument to fire
     * @memberof GuaranteedDebounce
     * @private
     * @instance
     * @type {*}
     */
    _arg

    /**
     * Attempt to execute function
     * @param {*} arg_ - Function arguments
     * @override
     */
    fire(arg_) {

        this._arg = arg_ //Store most recent args

        //Check if debouncing
        if (this._fire) {

            this._fire = false  //Begin debounce period

            //Perform debounce
            this.debounce().then(() => this._func(this._arg))

        }

    }

 }